import api from "../api/axios";

export const NATIONALITY_QUERY_KEY = ["nationalities"];
export const VIEW_NATIONALITY_QUERY_KEY = ["view-nationalities"];

export interface CreateNationalityPayload {
  code: string;
  name: string;
  status: number;
}

export interface UpdateNationalPaylod extends CreateNationalityPayload {}

export const nationalityService = {
  createNationality: async (payload: CreateNationalityPayload) => {
    const response = await api.post(`api/nationalities`, payload);
    return response.data;
  },
  updateNationality: async (id: number, payload: UpdateNationalPaylod) => {
    const response = await api.patch(`api/nationalities/${id}`, payload);
    return response.data;
  },
  getAllNationalities: async () => {
    const response = await api.get(`api/nationalities`);
    return response.data;
  },
  getNationalitiesById: async (id: number) => {
    const response = await api.get(`api/nationalities/${id}`);
    return response.data;
  },
  viewAllNationalities: async () => {
    const response = await api.get(`api/view-nationalities`);
    return response.data;
  },
  viewNationalitiesById: async (id: number) => {
    const response = await api.get(`api/view-nationalities/${id}`);
    return response.data;
  },
  toggleStatus: async (id: number) => {
    const response = await api.patch(`api/nationalities/${id}/toggle-status`);
    return response.data;
  },
};
